import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useFormSectionCardStyles = makeStyles(({ spacing, shadows, palette }) =>
  createStyles({
    card: {
      margin: spacing(2),
      paddingTop: 0,
      boxShadow: shadows[3],
      borderLeft: `0px solid ${palette.primary.dark}`,
      transition: 'border-left .25s',
      border: `1px solid ${palette.grey[200]}`,
    },
    cardSelected: {
      borderLeft: `7px solid ${palette.primary.main}`,
    },
    title: {
      paddingLeft: spacing(2.5),
      paddingTop: spacing(1.5),
      paddingBottom: spacing(1.5),
    },
    content: {
      padding: spacing(2.5),
      paddingTop: 0,
    },
  })
);

export default useFormSectionCardStyles;
